export const PERMISSIONS = {
  PROPERTIES: 'properties',
  LANDLORDS: 'landlords',
  TENANTS: 'tenants',
  AGENTS: 'agents',
  FICA: 'fica',
  PROPERTY_SEARCH: 'property_search',
  DASHBOARD: 'dashboard',
  USER_MANAGEMENT: 'user_management'
};

export const PERMISSION_LABELS = {
  [PERMISSIONS.PROPERTIES]: 'Properties',
  [PERMISSIONS.LANDLORDS]: 'Landlords',
  [PERMISSIONS.TENANTS]: 'Tenants',
  [PERMISSIONS.AGENTS]: 'Agents',
  [PERMISSIONS.FICA]: 'FICA',
  [PERMISSIONS.PROPERTY_SEARCH]: 'Property Search',
  [PERMISSIONS.DASHBOARD]: 'Dashboard',
  [PERMISSIONS.USER_MANAGEMENT]: 'User Management'
};

export const USER_ROLES = {
  MASTER: 'master',
  SUPERUSER: 'superuser',
  SUPERUSER_RENTAL: 'superuser_rental',
  SUPERUSER_SALES: 'superuser_sales',
  USER: 'user'
};

export const ROLE_LABELS = {
  [USER_ROLES.MASTER]: 'Master User',
  [USER_ROLES.SUPERUSER]: 'Super User',
  [USER_ROLES.SUPERUSER_RENTAL]: 'Super User Rental',
  [USER_ROLES.SUPERUSER_SALES]: 'Super User Sales',
  [USER_ROLES.USER]: 'Regular User'
};

const SUPER_ROLES = [USER_ROLES.MASTER, USER_ROLES.SUPERUSER, USER_ROLES.SUPERUSER_RENTAL, USER_ROLES.SUPERUSER_SALES];

export const hasPermission = (user, permission) => {
  if (!user) return false;
  const userRole = user.role || user.user?.role;
  if (SUPER_ROLES.includes(userRole)) return true;
  const userPermissions = user.permissions || user.user?.permissions;
  return userPermissions && userPermissions.includes(permission);
};

export const isMasterUser = (user) => {
  if (!user) return false;
  const userRole = user.role || user.user?.role;
  return userRole === USER_ROLES.MASTER;
};

export const hasRentalAccess = (user) => {
  if (!user) return false;
  const userRole = user.role || user.user?.role;
  return [USER_ROLES.MASTER, USER_ROLES.SUPERUSER, USER_ROLES.SUPERUSER_RENTAL].includes(userRole);
};

export const hasSalesAccess = (user) => {
  if (!user) return false;
  const userRole = user.role || user.user?.role;
  return [USER_ROLES.MASTER, USER_ROLES.SUPERUSER, USER_ROLES.SUPERUSER_SALES].includes(userRole);
};